import React, { useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../../firebaseConfig';

const Login = ({ setUser, setShowLogin, setShowRegister, setAckMessage }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            setUser(userCredential.user);
            setShowLogin(false);
            setAckMessage('Login successful!');
            setTimeout(() => setAckMessage(null), 3000);
        } catch (error) {
            console.error('Error logging in:', error);
        }
    };

    const handleGoogleLogin = async () => {
        const provider = new GoogleAuthProvider();
        try {
            const userCredential = await signInWithPopup(auth, provider);
            setUser(userCredential.user);
            setShowLogin(false);
            setAckMessage('Login successful!');
            setTimeout(() => setAckMessage(null), 3000);
        } catch (error) {
            console.error('Error logging in with Google:', error);
        }
    };

    return (
        <div>
            <form onSubmit={handleEmailLogin}>
                <h2>Email Login</h2>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <button type="submit" className="btn btn-primary">Login</button>
            </form>
            <button className="btn btn-danger mt-3" onClick={handleGoogleLogin}>Login with Google</button>
            <button type="button" className="btn btn-link mt-3" onClick={() => { setShowLogin(false); setShowRegister(true); }}>Register</button>
        </div>
    );
};

export default Login;